import { render, staticRenderFns } from "./UnitBuilder.vue?vue&type=template&id=c4d44d00&scoped=true&"
import script from "./UnitBuilder.vue?vue&type=script&lang=js&"
export * from "./UnitBuilder.vue?vue&type=script&lang=js&"
import style0 from "./UnitBuilder.vue?vue&type=style&index=0&id=c4d44d00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d44d00",
  null
  
)

component.options.__file = "UnitBuilder.vue"
export default component.exports